<template>
  <v-row
    class="mx-0 mt-0 mb-4"
    v-if="templateConfig.theme !== 'Operator-Template'"
  >
    <v-col>
      <v-form>
        <Alert
          v-if="showError"
          :message="error"
          type="error"
          @toggleAlert="showError = !showError"
        />
        <v-row>
          <v-col>
            <div
              text
              class="d-flex justify-center align-center mb-4 pricePlanBox"
            >
              <h2 class="font-weight-bold mx-3 priceCont text-center">
                {{ SubscribeFlowDetails.merchantOperatorDisclaimer.price }}
                {{ SubscribeFlowDetails.merchantOperatorDisclaimer.currency }}
              </h2>

              <div class="mx-3 text-center planCont">
                {{ SubscribeFlowDetails.subscriptionProductDetails.frequency }}
                {{ !templateConfig.isRtl ? $translate('PLAN') : '' }}
                <div class="trialLbl">
                  {{
                    SubscribeFlowDetails.subscriptionProductDetails
                      .freeTrialDays
                  }}
                  {{ $translate('DAYSFREETRIAL') }}
                </div>
              </div>
            </div>
          </v-col>
        </v-row>

        <v-row justify-space-between>
          <v-col>
            <v-btn
              block
              :loading="loading"
              :rounded="templateConfig.isButtonRounded"
              v-prevent-multiple-clicks:click="startSubscribe"
              class="mainButton"
            >
              <span v-html="trialConfirmBtnText" v-if="!loading"></span>
            </v-btn>
          </v-col>
        </v-row>
        <SecondaryDisclaimer v-if="afterTrialSecondaryDisclaimerText">
          <div
            class="secondryDisc"
            v-html="afterTrialSecondaryDisclaimerText"
          ></div>
        </SecondaryDisclaimer>
      </v-form>
    </v-col>
  </v-row>

  <!-- embedded template-->
  <v-row
    class="mx-0 mt-0 mb-4"
    v-else-if="templateConfig.theme == 'Operator-Template'"
  >
    <v-col>
      <v-form>
        <v-row class="justify-center">
          <v-col cols="12" sm="7" md="5" lg="4" xl="3">
            <Alert
              v-if="showError"
              :message="error"
              type="error"
              @toggleAlert="showError = !showError"
            />
          </v-col>
        </v-row>

        <v-row class="justify-center">
          <v-col cols="12" sm="4" md="3" class="py-0">
            <div text class="d-flex justify-center align-center pricePlanBox">
              <h2 class="font-weight-bold mx-3 priceCont text-center">
                {{ SubscribeFlowDetails.merchantOperatorDisclaimer.price }}
                {{ SubscribeFlowDetails.merchantOperatorDisclaimer.currency }}
              </h2>

              <div class="mx-3 text-center planCont">
                {{ SubscribeFlowDetails.subscriptionProductDetails.frequency }}
                {{ !templateConfig.isRtl ? $translate('PLAN') : '' }}
                <div class="trialLbl">
                  {{
                    SubscribeFlowDetails.subscriptionProductDetails
                      .freeTrialDays
                  }}
                  {{ $translate('DAYSFREETRIAL') }}
                </div>
              </div>
            </div>
          </v-col>
        </v-row>

        <v-row class="justify-center">
          <v-col cols="12" sm="4" md="3">
            <v-btn
              block
              :loading="loading"
              :rounded="templateConfig.isButtonRounded"
              v-prevent-multiple-clicks:click="startSubscribe"
              class="mainButton"
            >
              <span v-html="trialConfirmBtnText" v-if="!loading"></span>
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { startSubscribeMixin } from './startSubscribeMixin.js';
import SecondaryDisclaimer from '../../Shared/components/Disclaimer.vue';
import Alert from '../../Shared/components/Alert.vue';

export default {
  mixins: [startSubscribeMixin],
  data() {
    return {
      loading: false,
      showError: true,
      error: this.$translate('FREETRIALCONSUMED'),
    };
  },
  components: { SecondaryDisclaimer, Alert },
  computed: {
    ...mapState(['templateConfig', 'SubscribeFlowDetails', 'merchantConfig']),
    trialConfirmBtnText() {
      //Needs $replacePlaceholders plugin function for [productName] placeholders.
      return this.$replacePlaceholders(
        this.merchantConfig.texts.trialConfirmBtn,
        {
          productName:
            this.SubscribeFlowDetails.subscriptionProductDetails
              .initialProductName,
        }
      );
    },
    afterTrialSecondaryDisclaimerText() {
      //No need for $replacePlaceholders plugin function.
      return this.merchantConfig.texts.afterTrialSecondaryDisclaimer;
    },
  },
  methods: {
    ...mapMutations(['setSubscribeFlowDetails']),
  },
};
</script>
